var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock1Week(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_641_5688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9002 23.5995C10.9002 23.7995 3.60023 26.5995 3.70023 29.8995C3.80023 33.1995 11.2002 35.5995 20.2002 35.3995C29.2002 35.1995 36.5002 32.3995 36.4002 29.0995C36.3002 25.7995 28.9002 23.3995 19.9002 23.5995Z",
    fill: "url(#paint0_linear_641_5688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1453 35.3977C29.2 35.1764 36.4758 32.3563 36.3962 29.0988C36.3166 25.8413 28.9117 23.38 19.857 23.6013C10.8022 23.8226 3.52645 26.6427 3.60606 29.9002C3.68568 33.1577 11.0905 35.619 20.1453 35.3977Z",
    stroke: "url(#paint1_linear_641_5688)",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 26.8999C26.3996 26.6999 31.7996 28.4999 31.7996 30.8999C31.8996 33.1999 26.5996 35.2999 20.0996 35.3999C13.5996 35.4999 8.19963 33.7999 8.19963 31.3999C8.09963 29.0999 13.3996 26.9999 19.8996 26.8999Z",
    fill: "url(#paint2_linear_641_5688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1023 35.3006C26.6173 35.1414 31.8528 33.1324 31.7961 30.8135C31.7394 28.4946 26.4121 26.7439 19.897 26.9031C13.382 27.0623 8.14653 29.0712 8.2032 31.3901C8.25987 33.709 13.5873 35.4598 20.1023 35.3006Z",
    stroke: "url(#paint3_linear_641_5688)",
    strokeWidth: 0.19,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5V35.3",
    stroke: "url(#paint4_linear_641_5688)",
    strokeWidth: 0.19,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 19.6004C22.5409 19.6004 24.6004 17.5409 24.6004 15.0004C24.6004 12.4599 22.5409 10.4004 20.0004 10.4004C17.4599 10.4004 15.4004 12.4599 15.4004 15.0004C15.4004 17.5409 17.4599 19.6004 20.0004 19.6004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 19.6004C22.5409 19.6004 24.6004 17.5409 24.6004 15.0004C24.6004 12.4599 22.5409 10.4004 20.0004 10.4004C17.4599 10.4004 15.4004 12.4599 15.4004 15.0004C15.4004 17.5409 17.4599 19.6004 20.0004 19.6004Z",
    stroke: "url(#paint5_linear_641_5688)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 18.7008C22.0433 18.7008 23.6998 17.0442 23.6998 15.0008C23.6998 12.9573 22.0433 11.3008 19.9998 11.3008C17.9564 11.3008 16.2998 12.9573 16.2998 15.0008C16.2998 17.0442 17.9564 18.7008 19.9998 18.7008Z",
    stroke: "url(#paint6_linear_641_5688)",
    strokeWidth: 0.04,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 18.7008C22.0433 18.7008 23.6998 17.0442 23.6998 15.0008C23.6998 12.9573 22.0433 11.3008 19.9998 11.3008C17.9564 11.3008 16.2998 12.9573 16.2998 15.0008C16.2998 17.0442 17.9564 18.7008 19.9998 18.7008Z",
    fill: "url(#paint7_linear_641_5688)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_641_5688",
    x1: 20.0002,
    y1: 28.3199,
    x2: 20.0002,
    y2: 39.1236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8811,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_641_5688",
    x1: 19.6902,
    y1: 23.3106,
    x2: 20.2925,
    y2: 35.6259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_641_5688",
    x1: 20.0011,
    y1: 29.8983,
    x2: 20.0011,
    y2: 38.4083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_641_5688",
    x1: 19.8196,
    y1: 26.7882,
    x2: 20.2436,
    y2: 35.4578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C2460C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#953609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6D2707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#4B1B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#301103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#1B0A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0C0401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#030100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_641_5688",
    x1: "nan",
    y1: "nan",
    x2: "nan",
    y2: "nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA490C",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#7C2D07",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_641_5688",
    x1: 19.4742,
    y1: 20.1638,
    x2: 20.7384,
    y2: 10.5462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_641_5688",
    x1: 17.3089,
    y1: 17.1151,
    x2: 23.2784,
    y2: 12.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_641_5688",
    x1: 20.142,
    y1: 13.8709,
    x2: 20.2241,
    y2: 10.5092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_5688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock1Week);
export default __webpack_public_path__ + "static/media/lock-1-week.b6f68c64fa5c5c96a64b26d2ccfe1ef9.svg";
export { ForwardRef as ReactComponent };